import { ReactNode } from "react";

type FormInputType = "text" | "numeric" | "password";
export const FormInput = (
    { label, name, type, placeholder, valueChanged, value }:
        { name: string, label: string, type: FormInputType, placeholder?: string, valueChanged(e: string): void, value: string }) => {

    return (
        <input className="dlaksjdla" name={name} value={value} id={name} type={type} placeholder={placeholder ?? label} onChange={e => valueChanged(e.target.value)} />
    )
}


export const FormButton = ({ label, onClick }: { label: string, onClick(): void }) => {
    return (
        <button onClick={onClick} >
            {label}
        </button>
    )
}

export const Form = ({ children }: { children: ReactNode }) => {
    return (
        <div className='frm'>
            {children}
        </div>
    )
}

export const FormField = ({ label, children }: { label?: string, children: ReactNode }) => {
    return (
        <div className='frm-field'>
            <label>
                {!label ? "" : label}&nbsp;
            </label>
            <div className='input'>
                {children}
            </div>
        </div>
    )
}